import { useEffect } from 'react';
import { Toaster } from 'react-hot-toast';

import AlertState from '@/context/alert/AlertState.jsx';
import AppointmentState from '@/context/appointment/AppointmentState.jsx';
import DcCalendarState from '@/context/dccalendar/DcCalendarState.jsx';
import DcProfessionalState from '@/context/dcprofessional/DcProfessionalState.jsx';
import PatientState from '@/context/patient/PatientState.jsx';
import PatUserHealthProfileState from '@/context/patuserhealthprofile/PatUserHealthProfileState.jsx';
import PracUserAvailabilityState from '@/context/pracuseravailability/PracUserAvailabilityState.jsx';
import ProfessionalState from '@/context/professional/ProfessionalState.jsx';

import useLocations from '@/hooks/useLocations.js';
import usePrismic from '@/hooks/usePrismic.js';
import useProfessionalMappings from '@/hooks/useProfessionalMappings.js';
import useRequiredAuthCheck from '@/hooks/useRequiredAuthCheck.js';

import Navigation from './Navigation.jsx';
import './i18n.js';
import './scss/style.scss';

const App = () => {
    usePrismic();
    useLocations();
    useRequiredAuthCheck();
    useProfessionalMappings();

    useEffect(() => {
        if (import.meta.env.VITE_ENVIRONMENT === 'prod') {
            console.debug = () => {};
        }
    }, []);

    return (
        <AlertState>
            <PatientState>
                <ProfessionalState>
                    <AppointmentState>
                        <DcProfessionalState>
                            <DcCalendarState>
                                <PatUserHealthProfileState>
                                    <PracUserAvailabilityState>
                                        <Navigation />
                                        <Toaster />
                                    </PracUserAvailabilityState>
                                </PatUserHealthProfileState>
                            </DcCalendarState>
                        </DcProfessionalState>
                    </AppointmentState>
                </ProfessionalState>
            </PatientState>
        </AlertState>
    );
};

export default App;
